import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = /*#__PURE__*/ _createTextVNode("Scarica gli allegati per ");
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = { class: "" };
const _hoisted_9 = {
    key: 0,
    class: "d-flex align-items-center justify-content-end mt-2"
};
const _hoisted_10 = {
    key: 0,
    class: "fs-14 text-blue mr-3"
};
const _hoisted_11 = {
    key: 1,
    class: "fs-14 text-blue mr-3"
};
const _hoisted_12 = {
    key: 2,
    class: "text-center"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("button", { class: "btn btn-green" }, "Invia per approvazione", -1);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _component_gestore_allegati = _resolveComponent("gestore-allegati");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            (!_ctx.$store.state.isCliente())
                ? (_openBlock(), _createElementBlock("h4", _hoisted_2, "Allegati --> Cliente"))
                : (_openBlock(), _createElementBlock("h4", _hoisted_3, [
                    _hoisted_4,
                    _hoisted_5,
                    _createTextVNode(_toDisplayString(_ctx.task.title), 1)
                ])),
            _createElementVNode("div", null, [
                (_ctx.zipping)
                    ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-blue",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.downloadAsZip && _ctx.downloadAsZip(...args))),
                            disabled: _ctx.task.deliveryAttachments.length == 0
                        }, " Scarica come zip ", 8, _hoisted_6),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-green ml-2",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.openGallery(0))),
                            disabled: _ctx.task.deliveryAttachments.length == 0
                        }, " Vedi galleria ", 8, _hoisted_7)
                    ], 64))
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_gestore_allegati, {
                allegati: _ctx.task.deliveryAttachments,
                onDownload: _ctx.download,
                onRemove: _ctx.remove,
                readonly: _ctx.$store.state.isCliente(),
                onGallery: _ctx.openGallery
            }, null, 8, ["allegati", "onDownload", "onRemove", "readonly", "onGallery"])
        ]),
        (!_ctx.$store.state.isCliente())
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.modified)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Premi salva per aggiornare gli allegati ----> "))
                    : _createCommentVNode("", true),
                (_ctx.uploading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Sto caricando i file in background, puoi fare altro mentre aspetti "))
                    : _createCommentVNode("", true),
                (!_ctx.uploading)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-blue",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.save && _ctx.save(...args)))
                    }, " Salva allegati "))
                    : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true),
        (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 1 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.$store.state.isCollaboratore() && _ctx.showSendForApprovationButton)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "text-center",
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.sendForApprovation && _ctx.sendForApprovation(...args)))
                    }, _hoisted_14))
                    : _createCommentVNode("", true),
                ((_ctx.$store.state.isAdmin() || _ctx.$store.state.isOffice()))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (!_ctx.showApproveButton)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Il task deve essere \"In Approvazione\" per essere approvato"))
                            : _createCommentVNode("", true),
                        (!_ctx.task.gestimRequestIdentifier)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "btn btn-green",
                                disabled: !_ctx.showApproveButton,
                                onClick: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.approveAndDeliver && _ctx.approveAndDeliver(...args)))
                            }, " Approva e invia a cliente ", 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "btn btn-green",
                                disabled: !_ctx.showApproveButton,
                                onClick: _cache[5] || (_cache[5] =
                                    //@ts-ignore
                                    (...args) => (_ctx.sendBackToGestim && _ctx.sendBackToGestim(...args)))
                            }, " Approva e invia a GESTIM ", 8, _hoisted_18))
                    ]))
                    : _createCommentVNode("", true)
            ]))
    ]));
}
